export default __webpack_public_path__ + "static/media/phone.d017e1ae.svg";